import { useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { documentApi } from '../api/document';

type UpgradeCCTemplateParams = {
  documentId: number;
  ccTemplateVersionId: number;
};

type UseUpgradeCCTemplateOptions = {
  onSuccess?: () => void;
};

export const useUpgradeCCTemplate = ({
  onSuccess,
}: UseUpgradeCCTemplateOptions = {}) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({
      documentId,
      ccTemplateVersionId,
    }: UpgradeCCTemplateParams) => {
      return documentApi.update(
        { change_control_template_id: ccTemplateVersionId } as any,
        documentId,
        true,
      );
    },
    onSuccess: () => {
      void queryClient.invalidateQueries(['changeControlWithTemplate']);
      onSuccess?.();
    },
    onError: () => {
      showToast({
        id: 'upgrade-cc-template-error',
        status: 'error',
        title: t('notifications.error'),
        description: t('notifications.changeControlUpgradeFailed'),
        replace: true,
      });
    },
  });

  return { upgradeCCTemplate: mutateAsync, isLoading };
};
